export const assetPacks: IAssetPacks = {
  '1': {
    id: '1',
    name: 'Sci-fi',
    position: '1',
    thumbnail: '',
    tags: ['space', 'weapons', 'ship', 'plane', 'laser'],
  },
};
